import React, { SyntheticEvent } from 'react'
import { AvatarProps } from '../AvatarProps'

export enum LoadingStatus {
  ERROR = 'ERROR',
  LOADED = 'LOADED',
  PENDING = 'PENDING',
}

export const useImgProps: (avatarProps: AvatarProps) => { imgProps: AvatarProps['imgProps']; loaded: LoadingStatus } = (
  avatarProps,
) => {
  const [loaded, setLoaded] = React.useState<LoadingStatus>(LoadingStatus.PENDING)
  const imgProps = {
    ...avatarProps.imgProps,
    onLoad: (event: SyntheticEvent<HTMLImageElement, Event>) => {
      setLoaded(LoadingStatus.LOADED)
      avatarProps.imgProps?.onLoad?.(event)
    },
  }

  return { imgProps, loaded }
}
